"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Função que verifica se a data é válida.
 * @param date string no formato dd/mm/yyyy
 */
exports.checkValidDate = function (date) {
    if (!date)
        return false;
    if (!date.match(/^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/mg))
        return false;
    var d = date.split('/');
    var nd = new Date(+d[2], +d[1] - 1, +d[0]);
    // Verificação se a data existe ou não
    if (+d[2] !== nd.getFullYear() || +d[1] - 1 !== nd.getMonth() || +d[0] !== nd.getDate())
        return false;
    return true;
};
/**
 * Função que verifica se a data é maior que a de hoje
 * @param date string no formato dd/mm/yyyy
 */
exports.checkIfDateIsMoreThanToday = function (date) {
    if (!exports.checkValidDate(date))
        return false;
    var d = date.split('/');
    var nd = new Date(+d[2], +d[1] - 1, +d[0]);
    if (nd <= new Date())
        return false;
    return true;
};
/**
 * Função que verifica se a data é menor ou igual a de hoje
 * @param date string no formato dd/mm/yyyy
 */
exports.checkIfDateIsLessThanToday = function (date) {
    if (!exports.checkValidDate(date))
        return false;
    var d = date.split('/');
    var nd = new Date(+d[2], +d[1] - 1, +d[0]);
    if (nd > new Date())
        return false;
    return true;
};
/**
 * Função que verifica se a data é até no máximo a data de daqui 2 anos.
 * @param date string no formato dd/mm/yyyy
 */
exports.checkDateIsMax2YearsFromNow = function (date) {
    if (!exports.checkValidDate(date))
        return false;
    var d = date.split('/');
    var nd = new Date(+d[2], +d[1] - 1, +d[0]);
    var td = new Date();
    var f = new Date(td.getFullYear() + 2, td.getMonth(), td.getDate());
    if (nd > f)
        return false;
    return true;
};
